import { useEffect, useState } from "react";
import axiosInstance from "../axios/axiosInstance";

export interface SkiInfrastructureData {
  openLifts: number;
  totalLifts: number;
  openRuns: number;
  totalRuns: number;
}

export const useSkiInfrastructureStatistics = () => {
  const [skiInfrastructureStatistics, setSkiInfrastructureStatistics] =
    useState<SkiInfrastructureData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get<SkiInfrastructureData>(
        "/v1/client/kotelnica/ski-infrastructure-statistics"
      );
      setSkiInfrastructureStatistics(response.data);
    } catch (err) {
      console.error("Błąd podczas pobierania danych:", err);
      setError("Wystąpił błąd podczas pobierania danych");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetch = () => {
    fetchData();
  };

  return { skiInfrastructureStatistics, loading, error, refetch };
};
